import { IPromoCode, IPromoCodeCreate, IPromoCodeUpdate } from "../models/IPromoCode";
import { configWithUserToken } from "./config";

export const getPromoCodesByRestaurant = (restaurantId: string) =>
  configWithUserToken.get<IPromoCode[]>(`PromoCode/restourant/${restaurantId}`);

export const postPromoCode = (data: IPromoCodeCreate) =>
  configWithUserToken.post<IPromoCode>("PromoCode", data);

export const putPromoCode = (id: string, data: IPromoCodeUpdate) =>
  configWithUserToken.put<IPromoCode>(`PromoCode/${id}`, data);
